<template>
  <div class="firstRow">
    <div class="content-box">
      <div class="left">
        <span class="title">{{ fullTicketInfo.title }}</span>
      </div>
      <div class="right" @click="stateNotice = true">
        <span>Ticket Purchase Notice</span>
        <img src="~@/assets/image/common/common_goTo2.png" alt="">
      </div>
    </div>
    <remind
      @fullEvents="fullEvents"
      :currentNotice="fullTicketInfo"
      :stateNotice="stateNotice"
      :price="fullPrice">
    </remind>
  </div>
</template>

<script>
import remind from '@/components/buyTickets/common/remindEn'
export default {
  name: "firstRow",
  props: ['fullTicketInfo', 'fullPrice'],
  data(){
    return {
      stateNotice: false,
    }
  },
  methods:{
    fullEvents(options){
      const { type, stateNotice = null } = options;
      if(type === 'closeNotice')this.closeNotice(stateNotice);
      if(type === 'clickPay')this.clickPay();
    },
    closeNotice(){
      this.stateNotice = !this.stateNotice;
    },
    clickPay(){
      this.stateNotice = false;
      this.$emit('clickPay')
    }
  },
  components: {
    remind
  }
};
</script>

<style scoped lang='less'>
.firstRow{
  background: #FFFFFF;
  position: relative;
  padding: 0 .266667rem;
  margin-top: .266667rem;
  .content-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.52rem - .133333rem;
    border-bottom: 1px dashed #9D6C29;
    .left{
      font-weight: bold;
      display: flex;
      align-items: center;
      .title{
        font-size: .48rem;
        color: #222328;
        max-width: 10em;
      }
    }
    .right{
        font-size: .32rem;
        color: #333333;
        line-height: .44rem;
        display: flex;
        align-items: center;
        span{
          white-space: nowrap;
        }
        img{
          height: .32rem;
          margin-left: .066667rem;
        }
    }
  };
}
</style>
